import moment from 'moment';

import type {TeacherAssignmentRowFieldsFragment} from './queries/TeacherAssignments.queries.generated';

// "Due Tomorrow" reads relatively; far dates and ranges fall back to "MMM D".
const DUE_DATE_FORMATS = {
  sameDay: '[Today]',
  nextDay: '[Tomorrow]',
  nextWeek: 'MMM D',
  lastDay: '[Yesterday]',
  lastWeek: 'MMM D',
  sameElse: 'MMM D'
};

export const formatDateTime = (date: string) => moment(date).format('MMM D, h:mm A');
export const formatEditedDate = (date: string) => moment(date).format('MMM D, YYYY');
const formatDateShort = (date: string) => moment(date).format('MMM D');
const formatDueDate = (date: string) => moment(date).calendar(null, DUE_DATE_FORMATS);

// Due/start dates span the educator's in-scope (class, student) pairings, so cross-class
// rows show a min–max range and single-class rows collapse to one date.
export const formatDateRange = (
  min: string,
  max: string | null | undefined,
  formatSingle: (date: string) => string
): string =>
  max && max !== min ? `${formatDateShort(min)} - ${formatDateShort(max)}` : formatSingle(min);

// A row with no in-scope (class, student) pairings (e.g. every class archived or unenrolled) has
// null aggregates — show no date rather than the default settings date, which can match no class.
export const getDueCopy = (
  assignment: Pick<TeacherAssignmentRowFieldsFragment, 'minDueDate' | 'maxDueDate'>
): string =>
  assignment.minDueDate
    ? `Due ${formatDateRange(assignment.minDueDate, assignment.maxDueDate, formatDueDate)}`
    : '';
